<template>
  <!-- ##### Breadcumb Area Start ##### -->
    <div class="breadcumb-area bg-img">
        <div class="container h-100">
            <div class="row h-100 align-items-center">
                <div class="col-12 col-md-6">
                    <div class="breadcumb-text">
                        <h5>Iglesia La Senda Antigua</h5>
                        <h2>Dios te Bendiga</h2>
                        <p>
                            Y serán llenos tus graneros con abundancia, Y tus lagares rebosarán de mosto. <br>Proverbios 3:10
                        </p>
                    </div>
                </div>
                <div class="col-md-5">
                    <img src="img/missions/guatemala_bg.jpg" alt="ILSA" class="img-fluid ">
                </div>
            </div>
        </div>
    </div>
    <!-- <div class="container">
        <div class="row">
            <div class="col-md-6">
                <h5>Iglesia La Senda Antigua</h5>
                <h2>Dios te Bendiga</h2>
                <p>
                    Y serán llenos tus graneros con abundancia, Y tus lagares rebosarán de mosto. <br>Proverbios 3:10
                </p>
            </div>
            <div class="col-md-4">
                <img src="img/missions/assia_bg.jpg" alt="ILSA" class="img-fluid">
            </div>
        </div>
    </div> -->
</template>

<script>
export default {
    mounted(){
        let component = localStorage.getItem("component")|| "Home"
        setTimeout(() => {
            this.$router.push({name:component})
        }, 3000);
    }
}
</script>

<style>

</style>